import { DEL, GET, POST, PUT, setAuthToken } from "../config/ApiConfig";

const endPoint = "/credit-notes";

export const createCreditNote = async (user_token, formData) => {
  setAuthToken(user_token);
  return await POST(`${endPoint}/add-credit-note`, formData);
};

export const createFromInvoice = async (user_token, invoice_unique_id, formData = {}) => {
  setAuthToken(user_token);
  return await POST(`${endPoint}/create-from-invoice/${invoice_unique_id}`, formData);
};

export const getCreditNoteStats = async (user_token) => {
  setAuthToken(user_token);
  return await GET(`${endPoint}/credit-note-stats`);
};

export const getCreditNotes = async (user_token, params = {}) => {
  setAuthToken(user_token);
  const page = params.page || 1;
  const limit = params.limit || 10;
  const q = { ...params };
  delete q.user_token;
  delete q.page;
  delete q.limit;
  if (q._client_id === undefined || q._client_id === null || q._client_id === "") {
    delete q._client_id;
  }
  const query = new URLSearchParams(q).toString();
  const response = await GET(`${endPoint}/credit-note-list?page=${page}&limit=${limit}${query ? `&${query}` : ""}`);
  if (response?.status && response.data) {
    return response.data;
  }
  return { credit_notes: [], pagination: { total_rows: 0 } };
};

export const getCreditNoteDetails = async (param = {}) => {
  const user_token = param.user_token;
  const credit_note_unique_id = param.credit_note_unique_id;
  setAuthToken(user_token);
  const response = await GET(`${endPoint}/credit-note-details/${credit_note_unique_id}`);
  return response;
};

export const editCreditNote = async (user_token, id, formData) => {
  setAuthToken(user_token);
  return await PUT(`${endPoint}/update-credit-note/${id}`, formData);
};

export const removeCreditNote = async (user_token, id) => {
  setAuthToken(user_token);
  return await DEL(`${endPoint}/delete-credit-note/${id}`);
};

export const createCreditNoteItem = async (user_token, id, formData) => {
  setAuthToken(user_token);
  return await POST(`${endPoint}/add-item/${id}`, formData);
};

export const editCreditNoteItem = async (user_token, id, itemId, formData) => {
  setAuthToken(user_token);
  return await PUT(`${endPoint}/update-item/${id}/${itemId}`, formData);
};

export const removeCreditNoteItem = async (user_token, id, itemId) => {
  setAuthToken(user_token);
  return await DEL(`${endPoint}/delete-item/${id}/${itemId}`);
};

export const editCreditNoteShippingAddress = async (user_token, id, formData) => {
  setAuthToken(user_token);
  return await PUT(`${endPoint}/update-shipping-address/${id}`, formData);
};
